package org.example.project.cleaning

import androidx.compose.runtime.Composable
import org.example.project.engineletter.LetterEngine

@Composable
fun SysTextToPdfScreen() {
    LetterEngine()
}
